import { themeQuartz } from 'ag-grid-community';

export const shsThemeDark = themeQuartz.withParams({
    accentColor: 'rgb(var(--ui-3))',
    backgroundColor: 'var(--base-2)',
    borderColor: 'rgba(var(--ui-1), var(--opacity-75))',
    browserColorScheme: 'light',
    foregroundColor: 'var(--color-text-strong)',
    inputBackgroundColor: 'rgba(var(--ui-1), var(--opacity-50))'
});

export const shsAgGridThemeBorderless = themeQuartz.withParams({
    accentColor: 'rgb(var(--ui-3))',
    backgroundColor: 'var(--base-2)',
    borderColor: 'rgba(var(--ui-1), var(--opacity-75))',
    browserColorScheme: 'light',
    foregroundColor: 'var(--color-text-strong)',
    inputBackgroundColor: 'rgba(var(--ui-1), var(--opacity-50))',
    columnBorder: false,
    headerColumnBorder: false,
    headerRowBorder: { style: 'solid', width: 1, color: 'rgba(var(--ui-1), var(--opacity-75))' },
    rowBorder: { style: 'solid', width: 1, color: 'rgba(var(--ui-1), var(--opacity-50))' },
    wrapperBorder: false,
    sidePanelBorder: false,
    headerBackgroundColor: 'transparent',
    headerTextColor: 'var(--color-text-subtle)',
    headerFontSize: 14,
    headerFontWeight: 600,
    headerVerticalPaddingScale: 1,
    rowVerticalPaddingScale: 1.2,
    cellHorizontalPaddingScale: 1.1,
    fontSize: 14
});

export const shsThemeDarkTranslation = shsAgGridThemeBorderless;
